import React, { useEffect, useState } from "react";
import { useSanctum } from "react-sanctum";
import { ConfigProvider } from "antd";
import Main from "./layouts/Main";
import Auth from "./layouts/Auth";
import FullLoader from "./Helpers/FullLoader";
import { Navigate, useLocation } from "react-router-dom";

const App: React.FC = () => {
  const location = useLocation();
  const { authenticated, checkAuthentication } = useSanctum();
  const [networkStatus, setNetworkStatus] = useState<string>("active");

  useEffect(() => {
    const interval = setInterval(() => {
      checkAuthentication().catch((err) => {
        if (err.toJSON().message === "Network Error") {
          setNetworkStatus("failed");
        }
      });
    }, 1000 * 20); // every 20 seconds

    return () => clearInterval(interval); // Clear interval on component unmount
  }, [checkAuthentication]);

  if (authenticated === null && networkStatus === "failed") {
    return (
      <FullLoader
        message={"Error de conexión con el servidor, verifique internet!"}
      />
    );
  }

  if (authenticated === null) {
    return <FullLoader />;
  }

  if (authenticated === false && location.pathname !== "/") {
    return <Navigate to={"/"} />;
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1DA57A", 
        },
      }}
    >
      <div className="wrapper">{authenticated ? <Main /> : <Auth />}</div>
    </ConfigProvider>
  );
};

export default App;
